"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const moduleCodes = ["NEWS-01", "NEWS-02", "FACT-07", "LIVE-03", "ZONE-09", "OPIN-04", "OJOL-06", "REDA-08", "HAKJ-02", "KERS-05", "PEDO-01", "PRIV-07"];
export default function ProfileContent() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="2116" id="profile-content" className="relative overflow-hidden bg-background text-foreground py-28 md:py-36">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -right-16 md:-right-24 top-1/2 -translate-y-1/2 select-none font-serif font-light leading-none opacity-[0.06]" style={{
      fontSize: "clamp(360px, 52vw, 760px)",
      WebkitTextStroke: "1px var(--foreground)",
      color: "transparent"
    }}>
        PP
      </div>

      <div className="relative mx-auto max-w-[1440px] px-5 md:px-8 lg:px-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
          {}
          <div ref={leftRef} className={`lg:col-span-5 transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <div className="relative group">
              {}
              <div className="relative overflow-hidden rounded-lg aspect-[4/5] shadow-lg">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/jurnalis_lapangan_berita.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/jurnalis_lapangan_berita.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/jurnalis_lapangan_berita.png-wvc-sizes" alt="Jurnalis sedang meliput berita di lapangan" loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]" />

                {}
                <span aria-hidden="true" className="absolute top-3 left-3 w-3.5 h-3.5 border-t border-l border-primary opacity-90" />
                <span aria-hidden="true" className="absolute top-3 right-3 w-3.5 h-3.5 border-t border-r border-primary opacity-90" />
                <span aria-hidden="true" className="absolute bottom-3 left-3 w-3.5 h-3.5 border-b border-l border-primary opacity-90" />
                <span aria-hidden="true" className="absolute bottom-3 right-3 w-3.5 h-3.5 border-b border-r border-primary opacity-90" />

                {}
                <div aria-hidden="true" className="absolute left-0 top-0 bottom-0 w-8 overflow-hidden bg-secondary/30 backdrop-blur-[1px] border-r border-border/40">
                  <div className="absolute inset-x-0 top-0 flex flex-col items-center gap-6 py-4 animate-[marquee-y_60s_linear_infinite]" style={{
                  writingMode: "vertical-rl"
                }}>
                    {[...moduleCodes, ...moduleCodes].map((code, i) => <span data-index={i} key={i} className="font-mono text-[0.6875rem] font-medium tracking-[0.18em] text-foreground/80 whitespace-nowrap">
                        {code}
                      </span>)}
                  </div>
                </div>
              </div>

              {}
              <div className="mt-4 flex items-center justify-between">
                <span className="font-mono text-[0.6875rem] font-medium tracking-[0.18em] uppercase text-muted-foreground">
                  <span className="text-primary">§ LIVE.01</span>{" "}
                  <span>— LIPUTAN KHUSUS / AKTUAL / ZONA PP</span>
                </span>
              </div>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-7 lg:pl-6 transition-all duration-700 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            {}
            <div className="font-mono text-[0.6875rem] font-medium tracking-[0.18em] uppercase leading-none">
              <span className="text-primary">§ VISI</span>
              <span className="text-muted-foreground">
                {" "}
                — MISI KAMI / INTEGRITAS + KEADILAN INFORMASI
              </span>
            </div>

            {}
            <div className="mt-5 flex items-center gap-3">
              <Separator className="flex-1 bg-border" />
              <div className="flex items-center gap-1.5">
                <span className="block h-1 w-1 rounded-lg bg-primary" />
                <span className="block h-1 w-1 rounded-lg bg-primary" />
                <span className="block h-1 w-1 rounded-lg bg-primary" />
              </div>
            </div>

            {}
            <h2 className="mt-8 font-default text-foreground font-bold" style={{
            fontSize: "clamp(2.25rem, 4.8vw, 4.5rem)",
            letterSpacing: "-0.02em",
            lineHeight: 1.02
          }}>
              Berita yang{" "}
              <em className="font-serif italic font-light">tajam</em>, fakta
              yang <em className="font-serif italic font-light">teruji</em> secara
              akurat.
            </h2>

            {}
            <div className="mt-12">
              <div className="flex items-baseline justify-between gap-4">
                <h3 className="font-default text-foreground font-semibold" style={{
                fontSize: "clamp(1.125rem, 1.4vw, 1.5rem)",
                letterSpacing: "-0.005em",
                lineHeight: 1.3
              }}>
                  Tentang Jurnalisme Kami
                </h3>
                <span className="font-mono text-[0.6875rem] font-medium tracking-[0.18em] uppercase leading-none whitespace-nowrap">
                  <span className="text-primary">§ S1.1</span>
                </span>
              </div>
              <p className="mt-4 font-default text-muted-foreground max-w-[60ch]" style={{
              fontSize: "clamp(1.0625rem, 1.2vw, 1.25rem)",
              lineHeight: 1.55
            }}>
                Kami menyajikan informasi sebagai pilar demokrasi — independen, 
                berimbang, dan berani mengungkap kebenaran. Dari isu nasional hingga 
                suara akar rumput, setiap berita diverifikasi dengan ketat. Kami 
                percaya bahwa masyarakat yang terinformasi adalah masyarakat yang kuat.
              </p>
            </div>

            {}
            <div className="mt-12 flex items-center gap-3">
              <Separator className="flex-1 bg-border" />
              <div className="flex items-center gap-1.5">
                <span className="block h-1 w-1 rounded-lg bg-primary" />
                <span className="block h-1 w-1 rounded-lg bg-primary" />
                <span className="block h-1 w-1 rounded-lg bg-primary" />
              </div>
            </div>

            {}
            <div className="mt-12">
              <div className="flex items-baseline justify-between gap-4">
                <h3 className="font-default text-foreground font-semibold" style={{
                fontSize: "clamp(1.125rem, 1.4vw, 1.5rem)",
                letterSpacing: "-0.005em",
                lineHeight: 1.3
              }}>
                  Komitmen Klarifikasi
                </h3>
                <span className="font-mono text-[0.6875rem] font-medium tracking-[0.18em] uppercase leading-none whitespace-nowrap">
                  <span className="text-primary">§ S1.2</span>
                </span>
              </div>
              <p className="mt-4 font-default text-muted-foreground max-w-[60ch]" style={{
              fontSize: "clamp(1.0625rem, 1.2vw, 1.25rem)",
              lineHeight: 1.55
            }}>
                Di tengah arus disinformasi, kami hadir sebagai ruang klarifikasi. 
                Setiap laporan yang masuk diproses melalui meja redaksi yang profesional 
                untuk memastikan hak jawab dan kebenaran data tetap terjaga. Kami 
                mengukur keberhasilan dari kepercayaan pembaca dan dampak positif bagi publik.
              </p>
            </div>

            {}
            <div className="mt-14">
              <Button asChild variant="link" className="group h-auto p-0 text-primary hover:no-underline font-default font-medium">
                <Link to="/AboutUsPage" className="inline-flex items-center gap-2">
                  <span className="relative">
                    Baca selengkapnya tentang kami
                    <span aria-hidden="true" className="absolute left-0 -bottom-0.5 h-px w-full origin-left scale-x-0 bg-primary transition-transform duration-300 ease-[cubic-bezier(0.65,0,0.35,1)] group-hover:scale-x-100" />
                  </span>
                  <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes marquee-y {
          0% { transform: translateY(0); }
          100% { transform: translateY(-50%); }
        }
      `}</style>
    </section>;
}